// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1MdDE","requiredAsterisk":"Info_requiredAsterisk__ydiob"};